import AccessControlDialog from "@/components/call/access-controls/shared/dialog";
import { AccessControlActivateLoop } from "@EspaceParkQC/sdk-call-center";
import { toast } from "@EspaceParkQC/sdk-react";
import { RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ActivateLoop() {
  const { t } = useTranslation("main");

  function handleSubmit() {
    toast.loading(t("intercom.access-controls.activate-loop.submitting"));
  }

  function handleSuccess() {
    toast.success(t("intercom.access-controls.activate-loop.success"));
  }

  function handleError(error: unknown) {
    if (error instanceof Error) {
      toast.error(error.message);
    } else {
      toast.error(JSON.stringify(error));
    }
  }

  return (
    <AccessControlActivateLoop
      onError={handleError}
      onSuccess={handleSuccess}
      render={({ button, form }) => (
        <AccessControlDialog
          title={t("intercom.access-controls.activate-loop.title")}
          description={t("intercom.access-controls.activate-loop.description")}
          icon={<RefreshCw className="size-4" />}
          buttonProps={button}
          formProps={form}
          onSubmit={async () => handleSubmit()}
          formOnSubmit={async () => {
            await form.onSubmit();
          }}
          noReasonInput
        />
      )}
    />
  );
}
